import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { SafeArea } from 'capacitor-plugin-safe-area';
import { Device } from '@capacitor/device';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MobileHelperService {
    bottomTabMenuHeight = 58;
    bottomSpaceForMobile = 0;

    private safeAreaBottomSource = new BehaviorSubject<number>(0);
    public safeAreaBottom$: Observable<number> = this.safeAreaBottomSource.asObservable();

    private bottomSpaceForMobileSource = new BehaviorSubject<number>(0);
    public bottomSpaceForMobile$: Observable<number> = this.bottomSpaceForMobileSource.asObservable();

    constructor() {
        this.initializeSafeAreaInsets();
    }

    navigationBarGap(): number {
        // Part of the nav bar the WebView is already laid out above: the full bar on targetSdk 34
        // (48px 3-button, 24px gesture), 0 when edge-to-edge (Android 15+, targetSdk 35).
        return Math.max(0, window.screen.height - window.innerHeight);
    }

    initializeSafeAreaInsets(): void {
        SafeArea.getSafeAreaInsets().then(async (result) => {
            let safeAreaBottom = result.insets.bottom ?? 0;
            let bottomSpaceForMobile = this.bottomTabMenuHeight;
            if (Capacitor.getPlatform() === 'android') {
                try {
                    const deviceInfo = await Device.getInfo();
                    if (deviceInfo.osVersion && parseInt(deviceInfo.osVersion) > 14) {
                        bottomSpaceForMobile = this.bottomTabMenuHeight + safeAreaBottom;
                    } else {
                        safeAreaBottom = 0;
                    }
                } catch (error) {
                    console.warn('Failed to get device info for safe area workaround:', error);
                }
            }

            const navigationBarGap = this.navigationBarGap();
            if (navigationBarGap > 0) {
                safeAreaBottom = Math.max(0, safeAreaBottom - navigationBarGap);
                bottomSpaceForMobile = 0;
            }

            this.safeAreaBottomSource.next(safeAreaBottom);
            this.bottomSpaceForMobileSource.next(bottomSpaceForMobile);
        });
    }
}
